export default {
  private: {},
  "public": {
    "-LDqRfHuUcBDs8orS75Y": {
      key: "-LDqRfHuUcBDs8orS75Y",
      averageRating: 2,
      category: "react",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "The stateless functional component is a function that returns a jsx string. It can be passed props, but is by definition stateless",
      difficulty: "Easy",
      highscore: 59.996202771976456,
      id: "react-stateless-functional-component",
      snippet: "import React from 'react';\nconst MyComponent = props => <h1>{props.message}</h1>;\n",
      title: "React stateless functional component",
      snippetLength: 82
    },
    "-LDqZMwfFLRhYvBC_2Lu": {
      key: "-LDqZMwfFLRhYvBC_2Lu",
      category: "javascript",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "The reducer is an array function that takes an array and allows us to construct an accumulated value of any type.",
      difficulty: "Easy",
      highscore: 51.09803358690972,
      id: "array-function---sum-reducer",
      snippet: "const reducedSum = [1, 2, 3].reduce(\n  (accumulator, currentValue) => accumulator + currentValue,\n  0\n);\n",
      title: "Array function - sum reducer",
      snippetLength: 105
    },
    "-LDq_3vRsLcaN0_VpT4d": {
      key: "-LDq_3vRsLcaN0_VpT4d",
      category: "es2017",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "The Object.entries method returns an array containing arrays of the key value pairs of an object e.g Object.entries({a:1,b:2}) will return [['a','1'],['b',2]]",
      difficulty: "Easy",
      highscore: 73.17073170731709,
      id: "object-entries",
      snippet: "Object.entries({ a: 1, b: 2 });\n",
      title: "Object entries",
      snippetLength: 32
    },
    "-LDqe9W0JRmbbcJvusIc": {
      key: "-LDqe9W0JRmbbcJvusIc",
      averageRating: 5,
      category: "javascript",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Express router \nThe express Router allows us to abstract only the router module from express. This way we can define our routes in a modular fashion\n\n",
      difficulty: "Intermediate",
      highscore: 55.75139009749118,
      id: "express-router",
      snippet: "const express = require('express');\nconst app = express();\nconst itemsRouter = express.Router();\nconst items = [{ id: 0, name: 'item1' }, { id: 1, name: 'item2' }];\nitemsRouter.get('/:id', (req, res) => {\n  const { id } = req.params;\n  res.json(items.find(item => item.id === id));\n});\napp.use('items', itemsRouter);\n",
      title: "Express router",
      snippetLength: 317
    },
    "-LEAIwgVeZ8Ksaj-YkQo": {
      key: "-LEAIwgVeZ8Ksaj-YkQo",
      averageRating: 3,
      category: "es6",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# The array includes method.\nThe array includes tests the occurrence of a variable in an array. \n\n",
      difficulty: "Easy",
      highscore: 69.51322059235729,
      id: "array-includes-method",
      initialValue: "const array = [1, 2, 3, 4, 5];\n",
      snippet: "const array = [1, 2, 3, 4, 5];\narray.includes(2) && console.log('The array has the number 2');\n",
      title: "Array includes method",
      snippetLength: 95
    },
    "-LEAL2IWsnNtCaHvQrFn": {
      key: "-LEAL2IWsnNtCaHvQrFn",
      averageRating: 2,
      category: "es2017",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Adding string padding\nstring padding is something that's very handy when formatting strings. \n## Formatting numbers\nin the snippet, padding is added to the two number values day and year, by first coercing them into a string, and then performing the padStart string method. \nThis method takes as first argument the amount of minimum characters the string needs to be. \nThe second argument is the padding itself",
      difficulty: "Easy",
      highscore: 34.88304490223057,
      id: "string-padstart",
      initialValue: "const day = 2;\nconst month = 1;\nconst year = 2018;\n\n\n",
      snippet: "const day = 2;\nconst month = 1;\nconst year = 2018;\n\nconst formattedDate =\n  `${day.toString().padStart(2, '0')}` +\n  `/${month.toString().padStart(2, '0')}/${year}`;\n",
      title: "String padStart",
      snippetLength: 166
    },
    "-LEBlUELAOFw-R1iBbZt": {
      key: "-LEBlUELAOFw-R1iBbZt",
      averageRating: 3,
      category: "es2018",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Group named regex groups\nit is now possible to immediately name a regex capture group. \n\nAs shown in the snippet, \nsimply define the name in the (?<$VAR>$REGEX) format ($ are variables)\n",
      difficulty: "Hard",
      highscore: 29.910979228486646,
      id: "regex-named-group-captures",
      snippet: "const date = '28/04/2018';\nconst regex = /(?<day>\\d{2})\\/(?<month>\\d{2})\\/(?<year>\\d{4})/;\n\nconst { groups } = regex.exec(date);\nconsole.log(`The year is ${groups.year}`);\n\n",
      title: "Regex named group captures",
      snippetLength: 173
    },
    "-LEG_f9_B6bCpfOKX92b": {
      key: "-LEG_f9_B6bCpfOKX92b",
      averageRating: 2,
      category: "vim",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Change a word in vim\nchanging a word quickly can easily be done in vim by using the c command + movement\n\n```\nc + w replaces a word;\n```\n",
      difficulty: "Easy",
      highscore: 936,
      id: "change-word-in-vim",
      initialValue: "// Change a word in vim by pressing the 'c' and 'w' keys\nconstolre.log('Hallo');",
      snippet: "// Change a word in vim by pressing the 'c' and 'w' keys\nconsole.log('Hallo');",
      source: "",
      title: "Change word in vim",
      snippetLength: 78
    },
    "-LEJcGnf10dYPMk1zHGQ": {
      key: "-LEJcGnf10dYPMk1zHGQ",
      averageRating: 4,
      category: "javascript",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Sorting strings.\n## Array.sort()\nIn the array sort method, javascript reorders the items of an existing array using a comparing function. If the value is One, the item will move up in order of the array, if the item is -1 it will be moved down. When returning 0 it doesn't move. \n## To lowercase\nAs string comparison is done by converting the string to their unicode representation, capital letters are always higher than the lowercase ones. This is usually not the expected behaviour, so we need to compare the upper or lowercase values of the strings\n## Spread operator\nAs the Array sort method effectively mutes the original array, it is a good practice to copy the array. \nThe spread operator \"``...``\" spreads out all items of  an array and the square brackets create a new array. \nSo this: ```[...new Array(10)]``` for example creates an array with ten empty items  \n",
      difficulty: "Intermediate",
      highscore: 53.84892385252486,
      id: "sorting-strings",
      initialValue: "const strings = ['A', 'Z', 'b', 'x', 'c', 'D', 'e', 'a', 'r', 'a'];\n",
      snippet: "const strings = ['A', 'Z', 'b', 'x', 'c', 'D', 'e', 'a', 'r', 'a'];\nconst l = val => val.toLowerCase();\nconst sortStrings = (a, b) => (l(a) === l(b) ? 0 : l(a) < l(b) ? 1 : -1);\nconst sortedArray = [...strings].sort(sortStrings);\n",
      source: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort",
      title: "sorting strings",
      snippetLength: 230
    },
    "-LEKj1AIQo4mdrdqJqRQ": {
      key: "-LEKj1AIQo4mdrdqJqRQ",
      category: "nodejs",
      creator: "C7LEYUu3qgWh8SCDRZqjqDIY5pP2",
      description: "# Http createServer\nthe createServer method of the native http package in node.js allows for the easy creation of a web server without any dependencies. \n\nRunning this code and going to http://localhost:3000 will show a plain text result saying Hello World!",
      difficulty: "Easy",
      highscore: 47.14285714285714,
      id: "create-a-simple-http-server",
      initialValue: "",
      snippet: "const http = require('http');\nconst host = '127.0.0.1';\nconst port = 3000;\nconst server = http.createServer((req, res) => {\n  res.statusCode = 200;\n  res.setHeader('Content-Type', 'text/plain');\n  res.end('Hello World!\\n');\n});\nserver.listen((port, host, err) => {\n  console.log(`server running at http://${host}:${port}`);\n});\n",
      source: "https://nodejs.org/en/docs/guides/getting-started-guide/",
      title: "Create a simple http server",
      snippetLength: 328
    },
    "-LEPPlVV9oPRjxGtlrWD": {
      key: "-LEPPlVV9oPRjxGtlrWD",
      creator: "J6bxEZ2RfjfMQTqZnPSfqxh8LzF2",
      description: "sdfsdf",
      highscore: 78.19287576020851,
      id: "sdfsdf",
      initialValue: "",
      snippet: "const text = '2'",
      source: "sdf",
      title: "sdfsdf",
      snippetLength: 16
    },
    "-LEQYvwEs-MLbGKuVBcF": {
      key: "-LEQYvwEs-MLbGKuVBcF",
      averageRating: 2,
      category: "es2017",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Destructuring objects\n",
      difficulty: "intermediate",
      highscore: 37.95918367346939,
      id: "destructuring-objects",
      initialValue: "const obj = { a: 1, b: 2 };\n// Basic destructuring\n// Adding defaults\n// Adding custom names\n// Adding custom names and default values\n",
      snippet: "const obj = { a: 1, b: 2 };\n// Basic destructuring\nconst { a, b } = obj;\n// Adding defaults\nconst { c = 3 } = obj;\n// Adding custom names\nconst { a: d } = obj;\n// Adding custom names and default values\nconst { x: s = 4 } = obj;\n",
      source: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment",
      title: "Destructuring objects",
      snippetLength: 228
    },
    "-LEQxmhT1P78LnGyy0kH": {
      key: "-LEQxmhT1P78LnGyy0kH",
      averageRating: 4,
      category: "react",
      creator: "C7LEYUu3qgWh8SCDRZqjqDIY5pP2",
      description: "# Higher order component\n",
      difficulty: "Intermediate",
      highscore: 44.52617490560495,
      id: "higher-order-components",
      initialValue: "",
      snippet: "import React from 'react';\nimport { render } from 'react-dom';\nconst withCustomProp = Component => {\n  const WithCustomProp = props => (\n    <Component customProp=\"Hello World!\" {...props} />\n  );\n  return WithCustomProp;\n};\nconst App = withCustomProp(({ customProp }) => <h3>{customProp}</h3>);\nrender(<App />, document.querySelector('#root'));\n",
      source: "https://reactjs.org/docs/higher-order-components.html",
      title: "Higher order components",
      snippetLength: 346
    },
    "-LER16bi-xES3KmPrSoZ": {
      key: "-LER16bi-xES3KmPrSoZ",
      averageRating: 2,
      category: "react",
      creator: "C7LEYUu3qgWh8SCDRZqjqDIY5pP2",
      description: "# A very simple react component\nThis is a very basic example of a react component. The results of the render function will render onto the DOM element with the id of 'root'.\n ",
      difficulty: "intermediate",
      highscore: 49.09090909090909,
      id: "simple-react",
      initialValue: "",
      snippet: "import React from 'react';\nimport { render } from 'react-dom';\nclass App extends React.Component {\n  render() {\n    return (\n      <div>\n        <h1>Hello World!</h1>\n      </div>\n    );\n  }\n}\nrender(<App />, document.querySelector('#root'));\n",
      source: "",
      title: "Simple React ",
      snippetLength: 243
    },
    "-LEWqOBXyKBym9Xb4D6G": {
      key: "-LEWqOBXyKBym9Xb4D6G",
      category: "javascript",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Quick iteration hack\nQuick iteration to get all exponents of 2\n\nThe snippet spreads a newly created array of ten items `new Array(10) `, and spreads them out onto another newly created array created with square brackets. \n\nThen we map over each item and return 2 ^ index . This uses the new exponent infix operator. ** ",
      difficulty: "Intermediate",
      highscore: 43.2,
      id: "fast-iteration:w",
      initialValue: "",
      snippet: "const exponents = [...new Array(10)]\n.map((e, i) => 2 ** i);\n",
      source: "",
      title: "Fast iteration:w",
      snippetLength: 61
    },
    "-LEWsli0Z3sKuUrbD_Xg": {
      key: "-LEWsli0Z3sKuUrbD_Xg",
      averageRating: 2,
      category: "Browser APIs",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Prompting for user input\nTo prompt a user for input natively, we can easily use the window.prompt function. \nThis function will return the string the user has filled in.",
      difficulty: "Beginner",
      highscore: 57.95918367346938,
      id: "prompt-a-value",
      initialValue: "",
      snippet: "const name = prompt('What is your name?');\nconsole.log(`Hallo ${name}!`);\n",
      source: "",
      title: "Prompt a value",
      snippetLength: 74
    },
    "-LEY9YALmL8fj9E-cbHb": {
      key: "-LEY9YALmL8fj9E-cbHb",
      averageRating: 5,
      category: "rxjs",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# From event \nThis is how to listen to events using rxjs, fromEvent works similar to add Event Listener, only it returns an observable.  Then we use the scan operator, which works kind of like the reduce method. This increments the count variable on each iteration\n",
      difficulty: "Beginner",
      highscore: 50.82644628099174,
      id: "listen-to-button-click-with-rxjs",
      initialValue: "",
      snippet: "import { fromEvent } from 'rxjs';\nimport { scan } from 'rxjs/operators';\nconst { body } = document;\nfromEvent(body, 'click')\n  .pipe(scan(count => count + 1, 0))\n  .subscribe(e => console.log('clicked', e));\n",
      source: "",
      title: "Listen to button click with rxjs",
      snippetLength: 208
    },
    "-LEYFdNuz_r_eRm3uPxb": {
      key: "-LEYFdNuz_r_eRm3uPxb",
      averageRating: 5,
      category: "redux",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# The gist of redux\nThe state of the app is contained in the store, which is in turn created from a reducer. The reducer is a function responsible for updating the store. It takes the app state or store as a first argument and the action as the second.  We can dispatch actions by using the dispatch method of a store. These actions get handled by the store ",
      difficulty: "Beginner",
      highscore: 42.514796572989525,
      id: "the-gist-of-redux",
      initialValue: "",
      snippet: "import { createStore } from 'redux';\n\nconst reducer = (state = 0, action) => {\n  switch (action.type) {\n    case 'INCREMENT':\n      return state + 1;\n    case 'DECREMENT':\n      return state - 1;\n    default:\n      return state;\n  }\n};\nconst store = createStore(reducer);\nstore.subscribe(() => console.log(store.getState()));\n\nstore.dispatch({ type: 'INCREMENT' });\nstore.dispatch({ type: 'INCREMENT' });\nstore.dispatch({ type: 'DECREMENT' });\n",
      source: "https://redux.js.org/",
      title: "The gist of redux",
      snippetLength: 444
    },
    "-LE_p3mZ1ub0Qi1DV3-9": {
      key: "-LE_p3mZ1ub0Qi1DV3-9",
      averageRating: 5,
      category: "javascript",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Javascript proxy\n A javascript proxy is a class that can be used to catch traps on the target object that is provided to the proxy.  \nIn the example above, the handler only catches the get trap.\nThis trap tries to get the prop in the object passed to it. And returns the value we choose it to return (the string 'default').  \n\nIf we would console.log(p.b) it will return 'default', but if we would first set p.b =8; it will return 8\n ",
      difficulty: "Intermediate",
      highscore: 47.70038197571504,
      id: "default-values-by-using-proxy",
      initialValue: "",
      snippet: "const handler = {\n  get: (obj, prop) => (prop in obj ? obj[prop] : 'default')\n};\nconst p = new Proxy({}, handler);\nconsole.log(p.b)",
      source: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy",
      title: "Default values by using proxy",
      snippetLength: 131
    },
    "-LEfl7ZeXDgX4qfyVWje": {
      key: "-LEfl7ZeXDgX4qfyVWje",
      category: "react",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# React todo app\nThis is one of the demos on reactjs.org\nIt contains two components. The list and the app, which contains the list and also a form for submitting new todos .\n\n",
      difficulty: "Hard",
      id: "todo-app",
      initialValue: "",
      snippet: "class TodoApp extends React.Component {\r\n  constructor(props) {\r\n    super(props);\r\n    this.state = { items: [], text: '' };\r\n    this.handleChange = this.handleChange.bind(this);\r\n    this.handleSubmit = this.handleSubmit.bind(this);\r\n  }\r\n\r\n  render() {\r\n    return (\r\n      <div>\r\n        <h3>TODO</h3>\r\n        <TodoList items={this.state.items} />\r\n        <form onSubmit={this.handleSubmit}>\r\n          <label htmlFor=\"new-todo\">What needs to be done?</label>\r\n          <input\r\n            id=\"new-todo\"\r\n            onChange={this.handleChange}\r\n            value={this.state.text}\r\n          />\r\n          <button>Add #{this.state.items.length + 1}</button>\r\n        </form>\r\n      </div>\r\n    );\r\n  }\r\n\r\n  handleChange(e) {\r\n    this.setState({ text: e.target.value });\r\n  }\r\n\r\n  handleSubmit(e) {\r\n    e.preventDefault();\r\n    if (!this.state.text.length) {\r\n      return;\r\n    }\r\n    const newItem = {\r\n      text: this.state.text,\r\n      id: Date.now()\r\n    };\r\n    this.setState(prevState => ({\r\n      items: prevState.items.concat(newItem),\r\n      text: ''\r\n    }));\r\n  }\r\n}\r\n\r\nclass TodoList extends React.Component {\r\n  render() {\r\n    return (\r\n      <ul>\r\n        {this.props.items.map(item => <li key={item.id}>{item.text}</li>)}\r\n      </ul>\r\n    );\r\n  }\r\n}\r\n\r\nReactDOM.render(<TodoApp />, mountNode);\r\n",
      source: "https://reactjs.org",
      title: "Todo app ",
      snippetLength: 1325
    },
    "-LEjpzHmcAkkNcrTFpUV": {
      key: "-LEjpzHmcAkkNcrTFpUV",
      category: "socketio",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "",
      difficulty: "intermediate",
      highscore: 46.919472155938244,
      id: "simple-socket.io-on-nodejs-server",
      initialValue: "",
      snippet: "const app = require('http').createServer(handler);\nconst io = require('socket.io')(app);\nconst fs = require('fs');\nconst path = require('path');\napp.listen(80);\n\nconst handler = (req, res) => {\n  fs.readFile(path.join(__dirname, 'index.html'), (err, data) => {\n    if (err) {\n      res.writeHead(500);\n      return res.end('Error loading index.html');\n    }\n    res.writeHead(200);\n    res.end(data);\n  });\n};\n\nio.on('connection', socket => {\n  socket.emit('news', { hello: 'world' });\n  socket.on('other_event', data => {console.log(data)});\n  \n});\n",
      source: "",
      title: "simple socket.io on nodejs server",
      snippetLength: 550
    },
    "-LEnThNVW3UsfwR0KQ0W": {
      key: "-LEnThNVW3UsfwR0KQ0W",
      category: "nodejs",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Host files using http module\nThis is a naive implementation of how a file can be hosted by using only node.js and the http module.\n ",
      difficulty: "intermediate",
      id: "host-html-file-with-node.js",
      initialValue: "",
      snippet: "const http = require('http');\nconst fs = require('fs');\nconst { promisify } = require('util');\nconst { join } = require('path');\nconst readFile = promisify(fs.readFile);\n\nconst handler = async (req, res) => {\n  try {\n    const html = await readFile(join(__dirname, 'index.html'));\n    res.writeHead(200);\n    res.end(html);\n  } catch (e) {\n    res.writeHead(500);\n    res.end('Error loading index.html');\n  }\n};\n\nconst app = http.createServer(handler);\napp.listen(3334);\n",
      source: "",
      title: "Host html file with node.js",
      snippetLength: 471
    },
    "-LEojHrvWNcDkADqpgla": {
      key: "-LEojHrvWNcDkADqpgla",
      category: "javascript",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Array filter method\nThe filter method is an array prototype method that can be used to copy filtered out values from an array onto another. \nThe method will return only the values that are evaluated to true.",
      difficulty: "intermediate",
      highscore: 37.82312925170068,
      id: "array-filter-method",
      initialValue: "const arr = [0,'1', 'two', 3, 'four', undefined, null];\n// returns all strings ['1', 'two', 'four', 'five']\n\n// const weeds out all undefined and null values ['1', 'two', 'four']\n\n// return all that can be converted to number [0, '1', null, false]",
      snippet: "const arr = [0, '1', 'two', 3, 'four', undefined, null];\n// returns all strings ['1', 'two', 'four', 'five']\nconst onlyStrings = arr.filter(e => typeof e === 'string');\n// const weeds out all undefined and null values ['1', 'two', 'four']\nconst noNull = arr.filter(e => !!e);\n// return all that can be converted to number [0, '1', null, false]\nconst areNumbers = arr.filter(e => !isNaN(e));\n",
      source: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter",
      title: "Array filter method",
      snippetLength: 391
    },
    "-LEtux_fUQk4WIfGswS5": {
      key: "-LEtux_fUQk4WIfGswS5",
      category: "es2017",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Async/Await.\nThe above snippet is an async await function, invoked as  an IIFE.  The main purpose of async await is to try and make async easier to reason about by allowing the developers to write await where there is a async function that gets called, such as a promise. \n## Async\nThe async keyword tells the engine that the function is an async function. Behind the scenes it will compile the function to a promise of sorts. The result of an async function can also be `.then()`chained.\n## Await\nAt await, the function will wait until the promise is resolved before continuing onto the next line in the function.",
      difficulty: "Intermediate",
      highscore: 51.772105963469215,
      id: "async-await",
      initialValue: "",
      snippet: "(async () => {\n  const result = await fetch('https://httpstat.us/200');\n  console.log(result.text());\n})();\n",
      source: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function",
      title: "Async await",
      snippetLength: 108
    },
    "-LEu1Dy6P-lxmUedPTqw": {
      key: "-LEu1Dy6P-lxmUedPTqw",
      category: "Jasmine",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Simple jasmine example. \nThis snippet is an example of a very basic test written in Jasmine.\n## describe\nThe describe function is used to group tests. A group of such tests is often called a suite in jasmine. The describe function takes a string (to identify it with) and a function as parameters.\n## spec\nthe it function describes a spec. Just as the describe function takes a string and a parameter as functions, so does the it function. \n## Expect\nThis function is very straight forward. We pass in a value as its parameters, and what we expect this value will turn out in the toBe method. \n\n\n",
      difficulty: "intermediate",
      highscore: 57.49700536430394,
      id: "basic-jasmine-example",
      initialValue: "",
      snippet: "describe('suite', () => {\n  it('specification', () => {\n    expect(4 + 4).toBe(8);\n  });\n});\n",
      source: "",
      title: "Basic jasmine example",
      snippetLength: 93
    },
    "-LEu6VGDPr1Fj8Otjxq1": {
      key: "-LEu6VGDPr1Fj8Otjxq1",
      category: "nodejs",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Callbackify & Promisify \nThe callbackify and promisify functions are functions that provide backwards and forwards compatibility to node. \n## Promisify\nThe standard is moving towards promises, but as some popular libraries are still not using them, the promisify function makes it easier to implement promises for the user, not necessarily for the library makers. \n## Callbackify\nThe callbackify function on the other hand converts promises back to callbacks, because some code bases are not ready for promises yet, for instance. It's a very handy thing the node makers have implemented .\n",
      difficulty: "Intermediate",
      id: "promisify-and-callbackify",
      initialValue: "",
      snippet: "const { promisify, callbackify } = require('util');\nconst fs = require('fs');\nconst cb = callbackify(\n  () =>\n    new Promise((resolve, reject) => {\n      setTimeout(() => resolve('resolved!'), 2000);\n    })\n);\n\nconst promise = promisify(fs.readFile);\ncb((error, result) => {\n  console.log(result);\n});\npromise('./index.html').then(res => {\n  console.log(res.toString());\n});\n",
      source: "",
      title: "Promisify and callbackify",
      snippetLength: 376
    },
    "-LEuAjMTYWbl0LTZcSDm": {
      key: "-LEuAjMTYWbl0LTZcSDm",
      category: "nodejs",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Nodejs cluster\nNode does not use all processor cores by default, but it is possible to use clusters, which will implement separate workes that can each run on a different cpu core of your server. \n",
      difficulty: "intermediate",
      id: "nodejs-cluster",
      initialValue: "",
      snippet: "const cluster = require('cluster');\nconst http = require('http');\nconst numCPUs = require('os').cpus().length;\n\nif (cluster.isMaster) {\n  console.log(`Master ${process.pid} is running`);\n  [...new Array(numCPUs)].forEach(() => cluster.fork());\n  cluster.on('exit', (worker, code, signal) => {\n    console.log(`worker ${worker.process.pid} died`);\n  });\n} else {\n  http\n    .createServer((req, res) => {\n      res.writeHead(200);\n      res.end('running');\n    })\n    .listen(8080);\n  console.log(process.pid + ' running!');\n}\n",
      source: "",
      title: "Nodejs cluster",
      snippetLength: 525
    },
    "-LEuD5Oq0ZmW_ZaauQxf": {
      key: "-LEuD5Oq0ZmW_ZaauQxf",
      category: "Web API",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# The fetch web api\nfetch is a web api that provides a more user friendly api to make getting data easier in the browser. ",
      difficulty: "Easy",
      id: "fetch",
      initialValue: "",
      snippet: "fetch('https://jsonplaceholder.typicode.com/posts/1')\n    .then(response=> response.json())\n    .then(json => console.log(json))",
      source: "https://jsonplaceholder.typicode.com/",
      title: "fetch",
      snippetLength: 128
    },
    "-LEuwkzdaaTG_JKJjUVo": {
      key: "-LEuwkzdaaTG_JKJjUVo",
      category: "nodejs",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# The event Emitter \nThe event emitter class is a class that allows us to easily create emitters and listeners for custom events in node.js\nThis class mainly exposes two methods, on and emit. The on method allows us to hook listeners to events, the emit method dispatches events:\n",
      difficulty: "intermediate",
      highscore: 55.033557046979865,
      id: "event-emitter",
      initialValue: "",
      snippet: "const EventEmitter = require('events');\n\nclass CustomEmitter extends EventEmitter {}\n\nconst emitter = new CustomEmitter();\nemitter.on('EVENT', () => {\n  console.log('EVENT occured');\n});\nemitter.emit('EVENT');\n",
      source: "https://nodejs.org/api/events.html",
      title: "Event Emitter",
      snippetLength: 210
    },
    "-LEv-WESjkoYuGFh1ESF": {
      key: "-LEv-WESjkoYuGFh1ESF",
      category: "mongoose",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# The gist of mongoose\nThis snippet provides a basic example of how mongoose is implemented. \nBasically it connects to the database, creates a model, where new documents can be validated against, and stores documents to the database .",
      difficulty: "intermediate",
      id: "basic-mongoose",
      initialValue: "\n// mongoose connects to the local mongodb via connection string\n\n// mongoose.model defines a model. \n// We pass it a string, its name and an object, the schema\n\n// Now we have a model designed, \n// and we can create new instances by using the Model constructor\n\n// The model needs to be saved by using the save method, which returns a promise\n\n",
      snippet: "const mongoose = require('mongoose');\n// mongoose connects to the local mongodb via connection string\nmongoose.connect('mongodb://localhost/test');\n// mongoose.model defines a model. \n// We pass it a string, its name and an object, the schema\nconst Model = mongoose.model('Model', { name: String });\n// Now we have a model designed, \n// and we can create new instances by using the Model constructor\nconst naomiCampbell = new Model({ name: 'Naomi Campbell' });\n// The model needs to be saved by using the save method, which returns a promise\nnaomiCampbell.save().then(() => console.log('Neww model created'));\n",
      source: "http://mongoosejs.com/",
      title: "Basic mongoose",
      snippetLength: 610
    },
    "-LEv5X4LwnIS6DhUEvSG": {
      key: "-LEv5X4LwnIS6DhUEvSG",
      category: "mongoose",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Binding methods to mongoose models\nSometimes it  comes in handy if our model has a couple of methods, we can use so we can for instance add new fields, create tokens, ... \n",
      difficulty: "Intermediate",
      id: "mongoose-schema-methods",
      initialValue: "\n\n\n\n\n// the methods object will bind onto our newly created objects\n\n  // we use the this keyword, so we can't use arrow functions hee\n\n\n\n\n\n// this will console.log 'hello world, I am wally'\n\n",
      snippet: "const mongoose = require('mongoose');\nmongoose.connect('mongodb://localhost:27017/tests');\nconst userSchema = mongoose.Schema({\n  name: String\n});\n// the methods object will bind onto our newly created objects\nuserSchema.methods.sayHello = function() {\n  // we use the this keyword, so we can't use arrow functions hee\n  (this.name && console.log(`hello world, I am ${this.name}`)) ||\n    console.log('I have no name...');\n};\nconst User = mongoose.model('User', userSchema);\nconst wally = new User({ name: 'wally' });\n// this will console.log 'hello world, I am wally'\nwally.sayHello();\n",
      source: "http://mongoosejs.com/docs/index.html",
      title: "Mongoose schema methods",
      snippetLength: 587
    },
    "-LEvDVZA9j7bEXw_NUyD": {
      key: "-LEvDVZA9j7bEXw_NUyD",
      category: "design patterns",
      creator: "tSaAaF1u8ucxKE3ApZl3vCgzicl1",
      description: "# Singleton pattern\nThe singleton pattern restricts instantiation of the object to a single pattern, hence the name singleton. \n",
      difficulty: "Intermediate",
      highscore: 46.19350989708734,
      id: "singleton-pattern",
      initialValue: "",
      snippet: "const singleton = (() => {\n  let instance;\n  const init = () => {\n    const privateVariable = 'I am a private variable';\n    return {\n      publicMethod: () => console.log('Everyone can see me!'),\n      getPrivateVariable: () => console.log(privateVariable)\n    };\n  };\n  return {\n    getInstance: () => {\n      if (!instance) {\n        instance = init();\n      }\n      return instance;\n    }\n  };\n})();\nsingleton.getInstance().getPrivateVariable();\nsingleton.getInstance().publicMethod();\n                                             ",
      source: "",
      title: "Singleton pattern",
      snippetLength: 535
    }
  }
};